import { render, staticRenderFns } from "./AlarmDict.vue?vue&type=template&id=bbc4aabe&scoped=true&"
import script from "./AlarmDict.vue?vue&type=script&lang=js&"
export * from "./AlarmDict.vue?vue&type=script&lang=js&"
import style0 from "./AlarmDict.vue?vue&type=style&index=0&id=bbc4aabe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbc4aabe",
  null
  
)

export default component.exports